var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumTopicStyling = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C67BC",
    d: "M25 18.75a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-.75a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5H20a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 0 2.5 2.5h2a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5h-1.5a.5.5 0 0 1-.5-.5V32.5a2.5 2.5 0 0 0-2.5-2.5 2.5 2.5 0 0 0 2.5-2.5v-5.75a.5.5 0 0 1 .5-.5H27a.5.5 0 0 0 .5-.5v-2m7.5 0a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 0 2.5 2.5h.75a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5H40a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 0 .5-.5V32.5a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 0 1-2.5-2.5v-5.75a.5.5 0 0 0-.5-.5H33a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumTopicStyling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-topic-styling.628bd457372f817bb33e980be0ba34f9.svg";